import { IConfiguration } from './IConfiguration';

const startseiteEndpoint = 'https://www.arbeitsagentur.de/';
const profilEndpoint = 'https://web.arbeitsagentur.de/profil/profil-ui/pd/';

const config: IConfiguration = {
  // stage-abhängige Konfigurationen müssen hier definiert werden
  // Beispiel:
  // someEndpoint: (param1, param2) => `https://beispiel-url.de/${param1}/${param2}`,
  gebaerdenSprachEndpoint: 'https://www.arbeitsagentur.de/gebaerdensprache',
  leichteSprachEndpoint: 'https://www.arbeitsagentur.de/leichte-sprache',
  startseiteEndpoint: startseiteEndpoint,
  sucheEndpoint: 'https://web.arbeitsagentur.de/portal/metasuche/suche/information',
  glockenEndpoint: (scriptName) =>
    `https://web.arbeitsagentur.de/miso/miso-webcomponents/miso-glocke/${scriptName}`,
  //Profilmenue
  profilEndpoint: profilEndpoint,
  bescheideEndpoint: 'https://web.arbeitsagentur.de/besch/ui/pd/',
  termineEndpoint: 'https://web.arbeitsagentur.de/portal/termine/pd',
  verlaufEndpoint: 'https://web.arbeitsagentur.de/verlauf/verlauf-ui/pd/',
  einstellungenEndpoint: 'https://web.arbeitsagentur.de/profil/profil-ui/pd/einstellungen',
  maintenanceInfoUrl: 'https://rest.arbeitsagentur.de/cmsportal/cmsportal-api/pc/wartungshinweis',
  customLanguages: [],
  apiClientId: 'cms-ui',
};

export default config;
